var _style, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    className: "st0",
    width: 13,
    height: 22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25,
    className: "st1",
    width: 12,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 29,
    className: "st1",
    width: 12,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 33,
    className: "st1",
    width: 12,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 37,
    className: "st1",
    width: 12,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsDefault);
export default __webpack_public_path__ + "static/media/reports-default.eb9f7543881d89911b1b4c129e32f726.svg";
export { ForwardRef as ReactComponent };